export default "__VITE_ASSET__$VYh3z6n__"